<template>
  <div
    v-if="showMenu"
    data-sticky-container>
    <div
      class="floating-side-menu"
      data-btm-anchor="bottom-anchor:top"
      data-margin-bottom="20"
      data-margin-top="0"
      data-sticky
      data-top-anchor="top-anchor:top">
      <ul class="floating-side-menu__list">
        <li
          v-if="!isLoggedIn"
          class="floating-side-menu__item">
          <a
            :href="floatingSideMenu.login.link"
            :title="floatingSideMenu.login.title">
            <img :src="floatingSideMenu.login.icon" />
          </a>
        </li>
        <li
          v-if="isLoggedIn"
          class="floating-side-menu__item">
          <a
            :title="floatingSideMenu.logout.title"
            @click.prevent="logOut">
            <img :src="floatingSideMenu.logout.icon" />
          </a>
        </li>
        <li
          v-if="isLoggedIn"
          class="floating-side-menu__item">
          <a
            :href="floatingSideMenu.mydata.link"
            :title="floatingSideMenu.mydata.title">
            <img :src="floatingSideMenu.mydata.icon" />
          </a>
        </li>
        <li class="floating-side-menu__item">
          <a
            :href="floatingSideMenu.instagram.link"
            :title="floatingSideMenu.instagram.title">
            <img :src="floatingSideMenu.instagram.icon" />
          </a>
        </li>
        <li class="floating-side-menu__item">
          <a
            :href="floatingSideMenu.facebook.link"
            :title="floatingSideMenu.facebook.title">
            <img :src="floatingSideMenu.facebook.icon" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { GlobalStore } from "../../store/GlobalStore";
  import CustomerHelper from "../../helpers/CustomerHelper";

  export default {
    data() {
      return {
        floatingSideMenu: window.vueFloatingSideMenu,
        pagesWithHiddenMenu: [
          `error404`,
          `page-id-1515`,
          `page-id-19772`,
          `page-id-19847`,
          `page-id-19849`,
          `page-id-19850`,
          `page-id-19852`,
          `page-id-19853`,
          `page-id-20415`,
          `page-id-20418`,
          `page-id-20419`,
          `page-id-20421`,
          `page-id-20422`,
          `page-id-20424`,
          `page-id-20425`,
          `page-template-template-skintest-php`,
        ],
        showMenu: true,
      };
    },
    computed: {
      isLoggedIn() {
        return GlobalStore.user.isLoggedIn;
      },
    },
    mounted() {
      window.addEventListener(`DOMContentLoaded`, this.domContentLoaded);
    },
    beforeDestroy() {
      window.removeEventListener(`DOMContentLoaded`, this.domContentLoaded);
    },
    methods: {
      domContentLoaded() {
        this.linkOverride();
        this.hideMenu();
      },
      hideMenu() {
        if(document.querySelector(`.js-single-site`)
          || this.pagesWithHiddenMenu.find(element => document.body.classList.contains(element))) {
          this.showMenu = false;
        }
      },
      linkOverride() {
        if(!!document.querySelector(`.system-embed`)
          || !!document.querySelector(`.content-wrapper-biz`)
          || !!document.querySelector(`.content-wrapper-gallery`)) {
          this.floatingSideMenu.instagram.link = this.floatingSideMenu.instagram.bizLink;
          this.floatingSideMenu.facebook.link = this.floatingSideMenu.facebook.bizLink;
        }
      },
      async logOut() {
        await CustomerHelper.logout();
        window.location.reload();
      },
    },
  };
</script>

<style lang="less">
.floating-side-menu {
  &__list {
    height: 100%;
    left: 31px;
    list-style-type: none;
    margin: 0;
    position: absolute;
    text-align: center;
    top: 130px;
  }

  &__item {
    border-top: 1px solid black;
    padding: 20px 10px;
  }

  &__item img {
    height: 100%;
    max-height: 18px;
    max-width: 18px;
  }

  &__item:last-of-type {
    border-bottom: 1px solid black;
  }
}
</style>
